module.exports = __webpack_public_path__ + "img/dourbie-bouchon-vin.c78d0155.png";